import type { DocMigration } from "../docMigration";

function removeEmpty(input: any) {
  return Object.fromEntries(Object.entries(input).filter(([, value]) => value !== undefined && value !== null));
}

// copied from lib/studio/docGetElevations.ts
function docGetDefaultElevation(elevations: any, optionSet: any) {
  const defaultElevation = Object.values<any>(elevations).find((e) => !!e.isDefault);

  if (!!defaultElevation) {
    return defaultElevation;
  }

  return elevations[optionSet?.defaultValue];
}

// copied from lib/studio/elevation.ts
function copyForElevationOptionSet(existing: any, elevations: any) {
  const baseSettings = Object.fromEntries(
    Object.entries<any>(elevations).map(([id, { baseSettings }]) => [id, baseSettings]),
  );
  const cameraPositions = Object.fromEntries(
    Object.entries<any>(elevations).map(([id, el]) => [
      id,
      removeEmpty({
        defaultExteriorCamera: el.defaultExteriorCamera,
        topLeftPerspectiveCamera: el.topLeftPerspectiveCamera,
        topRightPerspectiveCamera: el.topRightPerspectiveCamera,
        bottomLeftPerspectiveCamera: el.bottomLeftPerspectiveCamera,
        bottomRightPerspectiveCamera: el.bottomRightPerspectiveCamera,
      }),
    ]),
  );
  const images = Object.fromEntries(
    Object.entries<any>(elevations).map(([id, el]) => [
      id,
      removeEmpty({ thumbnail: el.thumbnailUrl, rendered: el.rendered3DImageUrl }),
    ]),
  );

  const elevationIds = Object.keys(elevations);

  const defaultElevation = docGetDefaultElevation(elevations, existing);
  const defaultValue =
    [existing?.defaultValue, defaultElevation?.id].find((id) => elevationIds.includes(id as string)) || elevationIds[0];

  const options = Object.fromEntries(
    Object.entries<any>(elevations).map(([id, el]) => {
      const existingOption = existing?.options?.[id];
      return [
        id,
        {
          id,
          parentId: "elevationStyle",
          name: existingOption?.name || el.name,
          sortIndex: el.sortIndex,
          ...removeEmpty({
            price: existingOption?.price ?? el.price,
            description: existingOption?.description,
            builderOptionCode: existingOption?.builderOptionCode,
            builderTemplateCode: existingOption?.builderTemplateCode,
            salesImages: existingOption?.salesImages,
            priceTbd: existingOption?.priceTbd,
            disabled: existingOption?.disabled,
          }),
        },
      ];
    }),
  );

  return {
    id: "elevationStyle",
    entityType: "OPTION_SET",
    optionSetType: "ELEVATION",
    sortIndex: 0,
    name: "Elevation",
    category: existing?.category || "Elevations",
    tags: ["ELEVATION"],
    salesCategory: "DESIGN_ELEVATIONS",
    defaultValue,
    options,
    baseSettings,
    cameraPositions,
    images,
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_397: DocMigration = {
  maxSchemaVersion: "0.0.397",
  description: "Elevation option set cleanup and parity",
  apply(json: any) {
    json.optionSets.elevationStyle = copyForElevationOptionSet(json.optionSets.elevationStyle, json.elevations);
    return json;
  },
};

export default migration_0_0_397;
